import { setSearchTerm } from "../transportFeesDataReducer";
import { useSearch } from "../../../../core/util/storeHooks";

export const useTransportFeeSearch = () =>
  useSearch((s) => s.data.clearing.transportfees.searchTerm, setSearchTerm);
